import React from "react";

import { ContentType } from "../../constants";
import { trim } from "../helpers";
import { getFileMetaText } from "./helpers";

export default function ContentPreviewCompact({
  content,
  prefix = "✔",
  noLink,
  className,
  trimTextTo,
}: {
  content: Content;
  key?: any;
  prefix?: string;
  noLink?: boolean;
  className?: string;
  trimTextTo?: number;
}) {
  let text = "";

  if (content.type === ContentType.TEXT) {
    text = `${trim(content.value, trimTextTo || 50)} (${content.value.length})`;
  } else if (content.type === ContentType.FILE) {
    if (noLink) {
      text = content.meta?.name || "file";
    } else {
      text = getFileMetaText(content);
    }
  }

  return (
    <small className={typeof className !== "undefined" ? className : "block"}>
      {prefix && prefix !== "" ? `${prefix} ` : ""}
      {text}
    </small>
  );
}
